import React from 'react';
import { Icon } from '@/shared/icons';
import type { IconName } from '@/shared/icons';

interface WidgetHeaderIconProps {
  icon: IconName;
}

/**
 * Ícone padronizado para headers de widgets do dashboard.
 *
 * Container 28x28 com chip neutro (surface sunken) e ícone muted.
 * Centraliza o design em um único local para manter consistência.
 */
export const WidgetHeaderIcon: React.FC<WidgetHeaderIconProps> = ({ icon }) => {
  return (
    <div
      className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
      style={{ backgroundColor: 'var(--theme-surface-sunken)' }}
    >
      <Icon
        name={icon}
        className="h-3.5 w-3.5"
        style={{ color: 'var(--theme-muted-text)' }}
      />
    </div>
  );
};

WidgetHeaderIcon.displayName = 'WidgetHeaderIcon';
